module.exports = __webpack_public_path__ + "bin/6d8224b00fbfd629aec3b1cfefdb03a0.jpg";